import React from "react";
import { Navigate } from "react-router-dom";

// Dashboard
import Dashboard from "../pages/Admin/_Dashboard/index";

// Profile
import UserProfile from "../pages/Admin/Authentication/user-profile";

// Authentication related pages
import Login from "../pages/Admin/Authentication/Login";
import Logout from "../pages/Admin/Authentication/Logout";
import ForgetPwd from "../pages/Admin/Authentication/ForgetPassword";


//Pages
import Starter from "pages/Starter/Starter";
import RaterLogin from "pages/Rater/Authentication/RaterLogin";

// Aspirations Question
import ListPage from "pages/Admin/Aspirations/AspirationsQuestions/List/ListPage";
import TextListPage from "pages/Admin/Aspirations/AspirationsQuestions/List/TextListPage";

// Email
import EmailListPage from "pages/Admin/Email/List/ListPage";

// Aspirations Horizontal
import HorizontalListPage from "pages/Admin/Aspirations/SchorHorizontal/List/ListPage";
import TextHorizontalListPage from "pages/Admin/Aspirations/SchorHorizontal/List/TextListPage";

// Aspirations Vertical
import VerticalListPage from "pages/Admin/Aspirations/SchorVertical/List/ListPage";
import TextVerticalListPage from "pages/Admin/Aspirations/SchorVertical/List/TextListPage";

// Aspirations Vertical
import QuestionnaireListPage from "pages/Admin/Questionnaire/List/ListPage";
import TextQuestionnaireListPage from "pages/Admin/Questionnaire/List/TextListPage";

// batches
import BatchesListPage from "pages/Admin/Batches/List/ListPage";
import BatchesTrackListPage from "pages/Admin/Batches/List/Track/TrackListPage";
import ParticipantsListPage from "pages/Admin/Batches/List/ParticipantsListPage";
import ParticipantsTrackListPage from "pages/Admin/Batches/List/Track/ParticipantTrackListPage";

// Invitaions 
// Participants
import InvitationParticipantsListPage from "pages/Admin/Invitations/Participants/List/ListPage";
import InvitationParticipantsTextListPage from "pages/Admin/Invitations/Participants/List/TextListPage";
// Raters
import InvitationRatersListPage from "pages/Admin/Invitations/Raters/List/ListPage";
import InvitationRatersTextListPage from "pages/Admin/Invitations/Raters/List/TextListPage";

// Reminders 
// Participants
import RemindersParticipantsListPage from "pages/Admin/Reminders/Participants/List/ListPage";
import RemindersParticipantsTextListPage from "pages/Admin/Reminders/Participants/List/TextListPage";


// Configuration Language
import LanguageList from 'pages/Admin/Configurations/Language/ListPage'

// Norms
// Global
import GlobalList from 'pages/Admin/Norms/Global/List/ListPage'

// Group
import GroupList from 'pages/Admin/Norms/Group/List/ListPage'

// Group Questionnaire
import GroupQuestionnaireList from 'pages/Admin/Norms/Group/List/ListQuestionnairePage'

//Configurations survey welcome
import WelcomeList from 'pages/Admin/Configurations/Survey/Welcome/ListPage'

//Configurations survey middle
import MiddleList from 'pages/Admin/Configurations/Survey/Middle/ListPage'

//Configurations survey thank you
import ThankYouList from 'pages/Admin/Configurations/Survey/ThankYou/ListPage'

// Configuration ChartColor
import ChartColorList from 'pages/Admin/Configurations/ChartColor/ListPage'

//Configurations Raters type
import RatersType from 'pages/Admin/Configurations/RatersType/ListPage'
import RatersTypeText from 'pages/Admin/Configurations/RatersType/TextListPage'

// ******************************** => Participant // Rater Panel <= **************************************
//Participant Auth component
import ParticipantDashboard from "../pages/Participant/_Dashboard/index";
// Profile
import ParticipantUserProfile from "../pages/Participant/Authentication/user-profile";

// Authentication related pages
import ParticipantLogin from "../pages/Participant/Authentication/Login";
import ParticipantLogout from "../pages/Participant/Authentication/Logout";
import ParticipantForgetPwd from "../pages/Participant/Authentication/ForgetPassword";

// Raters invite page
import RaterInviteListPage from 'pages/Participant/RatersInvite/List'

// Complete Self Servey
import PhaseOne from 'pages/Participant/CompleteSelfServey/SurveyPhase/PhaseOne'
import PhaseThree from 'pages/Participant/CompleteSelfServey/SurveyPhase/PhaseThree'
import PhaseTwo from 'pages/Participant/CompleteSelfServey/SurveyPhase/PhaseTwo'
import PhaseFour from 'pages/Participant/CompleteSelfServey/SurveyPhase/PhaseFour'
import PhaseFive from 'pages/Participant/CompleteSelfServey/SurveyPhase/PhaseFive'
import PhaseSix from 'pages/Participant/CompleteSelfServey/SurveyPhase/PhaseSix'
import ServeyComplete from "components/Participant/CompleteSelfServey/CompleteSurvey/ServeyComplete";

// ******************************** => Rater Panel <= **************************************

import RaterDashboard from "../pages/Rater/_Dashboard/index";
// Complete Self Servey
import RaterPhaseOne from 'pages/Rater/CompleteSelfServey/SurveyPhase/PhaseOne'
import RaterPhaseThree from 'pages/Rater/CompleteSelfServey/SurveyPhase/PhaseThree'
import RaterPhaseTwo from 'pages/Rater/CompleteSelfServey/SurveyPhase/PhaseTwo'
import RaterPhaseFour from 'pages/Rater/CompleteSelfServey/SurveyPhase/PhaseFour'
import RaterPhaseFive from 'pages/Rater/CompleteSelfServey/SurveyPhase/PhaseFive'
import RaterPhaseSix from 'pages/Rater/CompleteSelfServey/SurveyPhase/PhaseSix'
import RaterServeyComplete from "components/Rater/CompleteSelfServey/CompleteSurvey/ServeyComplete";

const authProtectedRoutes = [
  // main dashboard
  { path: "/dashboard", component: <Dashboard /> },
  // Aspirations question
  { path: "aspirations/question/list", component: <ListPage /> },
  { path: "aspirations/question/text/list", component: <TextListPage /> },

  // Aspirations Horizontal
  { path: "aspirations/horizontal/list", component: <HorizontalListPage /> },
  { path: "aspirations/horizontal/text/list", component: <TextHorizontalListPage /> },

  // Aspirations Vertical
  { path: "aspirations/vertical/list", component: <VerticalListPage /> },
  { path: "aspirations/vertical/text/list", component: <TextVerticalListPage /> },

  // questionnaire Vertical
  { path: "questionnaire/list", component: <QuestionnaireListPage /> },
  { path: "questionnaire/text/list", component: <TextQuestionnaireListPage /> },

  // batches Vertical
  { path: "batches/list", component: <BatchesListPage /> },
  { path: "batches/track/list", component: <BatchesTrackListPage /> },
  { path: `participants/list/:batchId`, component: <ParticipantsListPage /> },
  { path: "participants/track/list", component: <ParticipantsTrackListPage /> },


  // Invitaion 
  // Participants
  { path: "invitations/participants/list", component: <InvitationParticipantsListPage /> },
  { path: "invitations/participants/text/list", component: <InvitationParticipantsTextListPage /> },

  // Raters
  { path: "invitations/raters/list", component: <InvitationRatersListPage /> },
  { path: "invitations/raters/text/list", component: <InvitationRatersTextListPage /> },

  // Reminders 
  // Participants
  { path: "reminders/participants/list", component: <RemindersParticipantsListPage /> },
  { path: "reminders/participants/text/list", component: <RemindersParticipantsTextListPage /> },


  // Email
  { path: "batch/email/list", component: <EmailListPage /> },

  //profile
  { path: "/profile", component: <UserProfile /> },

  //Configurations modules
  //Language configuration
  { path: "configurations/language/list", component: <LanguageList /> },

  //Language configuration
  { path: "configurations/chartcolor/list", component: <ChartColorList /> },

  // Norms
  { path: "norms/global/list", component: <GlobalList /> },
  { path: "norms/group/list", component: <GroupQuestionnaireList /> },
  { path: "norms/group/questionnaire/list", component: <GroupList /> },


  //configuration survey welcome
  { path: "configurations/survey/welcome/list", component: <WelcomeList /> },

  //configuration survey middle
  { path: "configurations/survey/middle/list", component: <MiddleList /> },

  // configuration survey thank you
  { path: "configurations/survey/thankyou/list", component: <ThankYouList /> },

  // configuration raters type
  { path: "configurations/raters-type/list", component: <RatersType /> },

  // configuration raters type text
  { path: "configurations/raters-type/text/list", component: <RatersTypeText /> },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: < Navigate to="/dashboard" />,
  },
];

const participantsRoutes = [
  // participant panel path
    //profile
  { path: "/profile", component: <ParticipantUserProfile /> },
  { path: "/dashboard", component: <ParticipantDashboard /> },

  // Raters invite page
  { path: "/participant/rater-invite", component: <RaterInviteListPage /> },

  { path: "/complete-self-servey/phase-one", component: <PhaseOne /> },
  { path: "/complete-self-servey/phase-two", component: <PhaseTwo /> },
  { path: "/complete-self-servey/phase-three", component: <PhaseThree /> },
  { path: "/complete-self-servey/phase-four", component: <PhaseFour /> },
  { path: "/complete-self-servey/phase-five", component: <PhaseFive /> },
  { path: "/complete-self-servey/phase-six", component: <PhaseSix /> },
  { path: "/save-survey", component: <ServeyComplete /> },
]

const raterRoutes = [
  // Rater panel path
  { path: "/dashboard", component: <RaterDashboard /> },
  { path: "/complete-self-servey/phase-one", component: <RaterPhaseOne /> },
  { path: "/complete-self-servey/phase-two", component: <RaterPhaseTwo /> },
  { path: "/complete-self-servey/phase-three", component: <RaterPhaseThree /> },
  { path: "/complete-self-servey/phase-four", component: <RaterPhaseFour /> },
  { path: "/complete-self-servey/phase-five", component: <RaterPhaseFive /> },
  { path: "/complete-self-servey/phase-six", component: <RaterPhaseSix /> },
  { path: "/save-servey", component: <RaterServeyComplete /> },
]

const publicRoutes = [
  { path: "/", component: <Starter /> },
  { path: "/logout", component: <Logout /> },
  { path: "/admin/login", component: <Login /> },
  { path: "/rater/login", component: <RaterLogin /> },
  { path: "/forgot-password", component: <ForgetPwd /> },

// ******************************** => Participant // Rater Panel <= **************************************
  { path: "/participant/login", component: <ParticipantLogin /> },
  { path: "/participant/logout", component: <ParticipantLogout /> },
  { path: "/participant/forgot-password", component: <ParticipantForgetPwd /> },
];

export { authProtectedRoutes, participantsRoutes, publicRoutes , raterRoutes};
